export function checkIfAnyVoteIsPaidFor(userSignupItems) {
  if (!userSignupItems || !Object.keys(userSignupItems).length) return false;

  let paidRespondentFound = false;

  Object.keys(userSignupItems).forEach((ID) => {
    const hasPaidRespondents = userSignupItems[ID].respondents?.some(
      (r) => r.paymentStatus === "Paid" || r.paymentStatus === "MarkedAsPaid"
    );
    if (hasPaidRespondents) paidRespondentFound = true;
  });

  return paidRespondentFound;
}
